<template>
    <div>
        <template v-if="!isDuoInternetAndMobile">
            <div class="col-12 bg-gray2">
                <div class="h4 mb-0">
                    {{ title }}
                </div>
            </div>
        </template>
        <div class="card" :class="isDuoInternetAndMobile ? 'mb-3' : 'my-1'">
            <div>
                <div v-if="showGlobalDiscountsLabel && totalDiscountsLabel" class="col-12 text-center banner-wrapper py-1 d-flex align-items-start justify-content-center ob1-tag bg-greige">
                    <span aria-hidden="true" class="icon text-primary icon-phone-fund-euro font-size-20" style="margin-right: 5px;" />
                    <strong v-text="totalDiscountsLabel" />
                </div>
            </div>
            <div :class="isDuoInternetAndMobile ? 'card-body p-1' : ''">
                <template v-if="internetDto">
                    <CartPageItem
                        v-for="(item, index) in internetDto.items"
                        :key="item.offerName ? item.offerName : 'cart-page-internet-item-'+index"
                        :dto="item"
                        :cross-sell-content="crossSellContent"
                        :is-internet-and-mobile-pack="isDuoInternetAndMobile"
                        @remove-item-from-cart-in-progress="$emit('remove-item-from-cart-in-progress', $event)"
                        @remove-item-from-cart-success="$emit('remove-item-from-cart-success', $event)"
                        @remove-item-from-cart-error="$emit('remove-item-from-cart-error', $event)"
                    />
                </template>
                <template v-if="hasCrossSellOffers && crossSellContent.showNewDesign">
                    <div class="row px-2 pb-1">
                        <div class="col-12 bg-greige">
                            <div class="row">
                                <div class="col-12 col-lg-7 py-1">
                                    <div class="bg-greige d-flex align-items-center">
                                        <div
                                            class="alert-icon text-primary font-size-28 me-1"
                                            :class="crossSellContent.pushIcon"
                                            aria-hidden="true"
                                        />
                                        <div>
                                            <div class="ob1-alert-title fw-bold">{{ crossSellContent.pushTitle }}</div>
                                            <div class="ob1-alert-title">{{ crossSellContent.pushSubTitleText }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5 d-flex justify-content-lg-end text-lg-end ps-4 ps-lg-0">
                                    <button
                                        data-bs-toggle="modal"
                                        :data-bs-target="'#'+crossSellContent.modalOffersLink.url"
                                        type="button"
                                        class="ob1-link-arrow"
                                        :aria-label=crossSellContent.modalOffersLink.label
                                        data-test-id="btn-popin-detail-forfait"
                                        :data-oevent-category=crossSellContent.modalOffersLink.tms.category
                                        :data-oevent-action=crossSellContent.modalOffersLink.tms.action
                                        :data-oevent-label=crossSellContent.modalOffersLink.tms.label
                                    >
                                        {{ crossSellContent.modalOffersLink.label }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <card-content-separator v-if="isDuoInternetAndMobile" :icon-class="'icon-Add text-primary'" />

                <template v-if="mobileDto">
                    <CartPageItem
                        v-for="(item, index) in mobileDto.items"
                        :key="item.offerName ? item.offerName : 'cart-page-mobile-item-'+index"
                        :dto="item"
                        :cross-sell-content="null"
                        :is-internet-and-mobile-pack="isDuoInternetAndMobile"
                        @remove-item-from-cart-in-progress="$emit('remove-item-from-cart-in-progress', $event)"
                        @remove-item-from-cart-success="$emit('remove-item-from-cart-success', $event)"
                        @remove-item-from-cart-error="$emit('remove-item-from-cart-error', $event)"
                    />
                </template>

                <template v-if="shouldShowDeviceInPack && deviceDto">
                    <CartPageItem
                        v-for="(item, index) in deviceDto.items"
                        :key="item.offerName ? item.offerName : 'cart-page-device-item-'+index"
                        :dto="item"
                        :is-internet-and-mobile-pack="isDuoInternetAndMobile"
                        @remove-item-from-cart-in-progress="$emit('remove-item-from-cart-in-progress', $event)"
                        @remove-item-from-cart-success="$emit('remove-item-from-cart-success', $event)"
                        @remove-item-from-cart-error="$emit('remove-item-from-cart-error', $event)"
                    />
                </template>

                <CartPageAdditionalAcquisition
                    v-if="promotionContent"
                    :dto="promotionContent"
                    @sponsor-success="$emit('sponsor-success', $event)"
                />
            </div>
        </div>
        <template v-if="hasCrossSellOffers && !crossSellContent.showNewDesign">
            <div
                v-for="(item, index) in internetDto.items"
                :key="'cart-page-cross-sell-item-'+index"
                class="d-flex flex-column justify-content-center align-items-center pt-1"
            >
                <a class="ob1-link no-decoration" href="#cross-sell-content">
                    <span class="ob1-link-icon-text" v-text="item.crossSellLinkLabel" />
                    <span class="icon icon-arrow-down d-block text-center pt-custom" />
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import CardContentSeparator from "../../../showcase/components/CardContentSeparator.vue";
import CartPageItem from "./CartPageItem.vue";
import CartPageAdditionalAcquisition from "./CartPageAdditionalAcquisition.vue";

export default {
    name: 'CartPageInternetMobileDevicePackContent',
    components: {
        CartPageAdditionalAcquisition,
        CartPageItem,
        CardContentSeparator
    },
    props: {
        internetDto: {
            type: Object,
            required: false,
            default: undefined
        },
        mobileDto: {
            type: Object,
            required: false,
            default: undefined
        },
        crossSellContent: {
            type: Object,
            required: false,
            default: null
        },
        promotionContent: {
            type: Object,
            required: false,
            default: null
        },
        totalDiscountsLabel: {
            type: String,
            default: null
        },
        deviceDto: {
            type: Object,
            required: false,
            default: undefined
        }
    },
    computed: {
        title() {
            return this.internetDto?.title || this.mobileDto?.title;
        },
        hasCrossSellOffers() {
            return this.internetDto && this.crossSellContent;
        },
        isDuoInternetAndMobile: function() {
            return !!(this.internetDto && this.mobileDto);
        },
        shouldShowDeviceInPack: function() {
            return !!(this.internetDto && this.mobileDto && this.deviceDto);
        },
        showGlobalDiscountsLabel: function () {
            const hasInternetDiscountLabel = this.internetDto?.items.some(item => item.discountLabel) || false;
            const hasMobileDiscountLabel = this.mobileDto?.items.some(item => item.discountLabel) || false;

            return (this.internetDto && this.mobileDto) || (!hasInternetDiscountLabel && !hasMobileDiscountLabel);
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';

.icon {
    font-size: 18px;
}

.pt-custom {
    padding-top: px-to-rem(7) !important;
}
</style>
